import React, { useEffect, useState } from 'react';
import { api } from '../utils/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { AlertTriangle } from 'lucide-react';
import { toast } from 'sonner';

const StockAdjustments = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    product_id: '',
    quantity: 1,
    reason: 'quebra'
  });

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const res = await api.products.getAll();
      setProducts(res.data);
    } catch (error) {
      toast.error('Erro ao carregar produtos');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.product_id) {
      toast.error('Selecione um produto');
      return;
    }
    setLoading(true);
    try {
      await api.stockAdjustments.create(formData);
      toast.success('Baixa registrada com sucesso!');
      setFormData({ product_id: '', quantity: 1, reason: 'quebra' });
      fetchProducts();
    } catch (error) {
      toast.error('Erro ao registrar baixa');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto space-y-6" data-testid="stock-adjustments-page">
      <h1 className="text-5xl font-bold uppercase tracking-tight">Baixas de Estoque</h1>
      
      <Card className="bg-card border-border">
        <CardHeader>
          <CardTitle className="flex items-center gap-2 uppercase tracking-wide text-xl">
            <AlertTriangle className="text-primary h-6 w-6" />
            Registrar Perda / Cortesia
          </CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label className="uppercase text-xs font-bold tracking-wider mb-2 block">Produto</Label>
              <Select value={formData.product_id} onValueChange={(val) => setFormData({...formData, product_id: val})}>
                <SelectTrigger className="font-mono">
                  <SelectValue placeholder="Selecione o produto" />
                </SelectTrigger>
                <SelectContent className="bg-card border-border">
                  {products.map(p => (
                    <SelectItem key={p.id} value={p.id}>
                      {p.name} (Atual: {p.stock})
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <Label className="uppercase text-xs font-bold tracking-wider mb-2 block">Quantidade</Label>
                <Input 
                  type="number" 
                  value={formData.quantity} 
                  onChange={(e) => setFormData({...formData, quantity: parseInt(e.target.value) || 1})}
                  className="font-mono"
                  min="1"
                  required
                />
              </div>
              <div>
                <Label className="uppercase text-xs font-bold tracking-wider mb-2 block">Motivo da Baixa</Label>
                <Select value={formData.reason} onValueChange={(val) => setFormData({...formData, reason: val})}>
                  <SelectTrigger className="font-mono">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent className="bg-card border-border">
                    <SelectItem value="quebra">Quebra / Estragou</SelectItem>
                    <SelectItem value="perda">Perda / Sumiço</SelectItem>
                    <SelectItem value="cortesia">Cortesia / Consumo Interno</SelectItem>
                    <SelectItem value="vencimento">Vencimento</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>

            <Button type="submit" disabled={loading} className="w-full bg-primary hover:bg-primary/90 text-primary-foreground font-bold uppercase h-12 mt-4">
              {loading ? 'Processando...' : 'Confirmar Baixa de Estoque'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default StockAdjustments;
